import {
  Divider,
  InformationSnippetGroup,
  Typography,
} from 'br2s-ui-componentlibrary_r2_02';
import './InstructionHeader.scss';
import Richtext from '@/components/Richtext/Richtext';
import { getAreaComponents } from '@/utilities/functions/magnoliaUtils';


export interface InstructionHeaderProps {
  title: string;
  subTitle: string;
  introTable: {
    icon: string,
    introTableLabel: string,
    introTableDescription: string
  }[]
}

function InstructionHeader({
  title,
  introTable,
  subTitle
}: InstructionHeaderProps) {
  const tableItems = introTable ? getAreaComponents(introTable) : [];

  return (
    <div
      id="instruction-introduction-container"
      className="instruction-introduction-header-container"
    >
      <div className="introduction-title">
        <Typography type="headline-3" weight="bold" label={title} />
      </div>
      {subTitle && <div className="introduction-subtitle"><Richtext content={subTitle}/></div>}
      <div className="introduction-divider">
        <Divider id="instruction-introduction-divider" />
      </div>
      {tableItems.length > 0 &&
        <div className="introduction-form">
          <InformationSnippetGroup
            id="introduction-form-details"
            layout="form-summary"
            data={
              tableItems && tableItems.length ? tableItems.map((item: any) => {
                return {
                  labelIconClassName: `icon-sys icon-sys-${item.icon}`,
                  label: item.introTableLabel,
                  children: <Richtext content={item.introTableDescription} />
                }
              }) : []
            }
            numberOfCol={2}
          />
        </div>
      }
    </div>
  );
}

export default InstructionHeader;
